// 屏蔽所有用户操作收集
export function trackIdentify (userid: string, traits: any) {
  window.analytics.identify(userid, traits)
  return new Promise((resolve, reject) => {
    // https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#identify
    window.analytics.identify(userid, traits, {}, (err: any) => {
      if (err) {
        return reject(err)
      }
      resolve(true)
    })
  })
}

export function track (eventName: string, properties: any) {
  return new Promise((resolve, reject) => {
    window.analytics.track(eventName, properties, {}, (err: any) => {
      if (err) {
        return reject(err)
      }
      resolve(true)
    })
  })
}

export function trackPage (name: string) {
  return window.analytics.page(name)
}

export function trackButtonClick (title: string, properties = {}) {
  return track('button-clicked', { title, ...properties })
}
